export const state = {
  estado: {},
  estados: [],
};

export default {};
